import { GET_DEPARTAMENTOS, GET_DEPARTAMENTO_ESPECIFICO, GET_OPERADORES, GET_DEPARTAMENTO_USE } from './mutation-types'

export default {
  [GET_DEPARTAMENTOS]: (state, departamentos) => {
    state.departamentos = departamentos
  },

  [GET_DEPARTAMENTO_ESPECIFICO]: (state, departamento) => {
    state.departamento = departamento
  },

  [GET_DEPARTAMENTO_USE]: (state, departamentoUse) => {
    state.departamentoUse = departamentoUse
  },

  [GET_OPERADORES]: (state, operadores) => {
    state.operadores = operadores
  },
}
